import { render, staticRenderFns } from "./chouqian.vue?vue&type=template&id=47076b4a&scoped=true"
import script from "./chouqian.vue?vue&type=script&lang=js"
export * from "./chouqian.vue?vue&type=script&lang=js"
import style0 from "./chouqian.vue?vue&type=style&index=0&id=47076b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47076b4a",
  null
  
)

export default component.exports